export default __webpack_public_path__ + "media/images/icons_fc/danger-f591d02ecd9bcd1a48a037211224136c.png";